import { FC, HTMLAttributes, memo, useEffect, useRef } from 'react';
import { Address } from 'olo-service';
import clsx from 'clsx';

import style from './Map.module.scss';
import { MAP_TEST_ID } from './Map.const';
import { useGoogleMapsScript } from 'hooks/useGoogleMapsScript/useGoogleMapsScript';

function createAddressString({ address1, city, state }: Address) {
  return [address1, city, state].join();
}

export const Map: FC<HTMLAttributes<HTMLDivElement> & { address: Address }> = memo(({ address, ...props }) => {
  const mapRef = useRef<HTMLDivElement>(null);

  const { googleMapsLoaded } = useGoogleMapsScript();

  useEffect(() => {
    if (!googleMapsLoaded) return;

    const geoCoder = new google.maps.Geocoder();

    geoCoder.geocode({ address: createAddressString(address) }, (results, status) => {
      if (status !== google.maps.GeocoderStatus.OK || !mapRef.current) return;

      const { location } = results[0].geometry;

      const map = new google.maps.Map(mapRef.current, { center: location, zoom: 18 });

      new google.maps.Marker({ position: location, map });
    });
  }, [address, googleMapsLoaded]);

  if (!googleMapsLoaded) return null;

  return <div {...props}><div className={clsx(style.map)} ref={mapRef} data-testid={MAP_TEST_ID} /></div>;
});
